import React from "react";
import "./style.css";
import { Col, Row } from "react-bootstrap";
// import { Contact } from "../Contact";
import Social from "../Social";

const Basics = (props) => {
  const { name, label, profiles } = props;
  return (
    <>
      <Row>
        {" "}
        <Col md={9} xm={12}>
          <h1 className="name">{name}</h1>

          <h3 className="label">{label}</h3>
          <Social {...profiles} />
          {/* <Contact {...profiles} /> */}
        </Col>
        <Col
          xs={6}
          md={3}
          style={{
            display: "flex",
            padding: "0",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {" "}
          <Row>
            <img
              // style={{ maxWidth: "50%" }}
              style={{ width: "auto", height: "200px" }}
              src="profile.jpeg"
              alt="Bar Horing Amir"
              title="That's me"
            />
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Basics;
